<template>
  <b-nav-item-dropdown
    right
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ userData.Name }}
        </p>
        <span class="user-status">{{ userData.nameProfile }}</span>
      </div>
      <b-avatar
        size="40"
        :src="avatarSrc"
        @img-error="onAvatarError"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
        style="object-fit: contain !important"
      >
        <feather-icon v-if="!userData.Name" icon="UserIcon" size="22" />
      </b-avatar>
    </template>
    <b-dropdown-item
      v-if="activeUserRole"
      link-class="d-flex align-items-center"
      @click="onCompany"
    >
      <feather-icon size="16" icon="UserIcon" class="mr-50" />
      <span>
        {{ $t("profileCompany") }}
      </span>
    </b-dropdown-item>
    <b-dropdown-item link-class="d-flex align-items-center" @click="logout">
      <feather-icon size="16" icon="LogOutIcon" class="mr-50" />
      <span>
        {{ $t("logout") }}
      </span>
    </b-dropdown-item>
  </b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown,
  BDropdownItem,
  BDropdownDivider,
  BAvatar,
} from "bootstrap-vue";
import { initialAbility } from "@/libs/acl/config";
// import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from "@core/utils/filter";
import { deleteCookie, getCookie, setCookie } from "@/auth/CookiesManager";

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      avatarText,
      userData: {},
      avatarText,
      avatarError: false,
      fallbackAvatar:
        require("@/assets/images/portrait/small/avatar-s-11.jpg").default ||
        require("@/assets/images/portrait/small/avatar-s-11.jpg"),
    };
  },
  computed: {
    activeUserRole() {
      const role = this.$store.state.appConfig.role;
      const isEmployee = this.$store.getters["appConfig/isEmployee"];
      if (role !== "BACKOFFICE" && !isEmployee) return true;
    },

    currentUser() {
      return this.$store.state.appConfig.user;
    },

    avatarSrc() {
      if (this.avatarError || !this.userData?.photo) {
        return this.fallbackAvatar;
      }
      return this.userData.photo;
    },
  },

  watch: {
    currentUser: {
      immediate: true,
      handler(val) {
        this.userData = val || {};
      },
    },
  },

  created() {
    // this.userData = this.$store.state.appConfig.user;
  },
  methods: {
    onCompany() {
      const guid = this.$store.state.appConfig.activeCompanyGuid;
      if (!guid) {
        // this.$toast.error(this.$t("companyNotFound"));
        return;
      }
      this.$router.push({
        name: "company",
        params: {
          option: 3, // option 3 to edit
          guid: guid,
        },
      });
    },

    onAvatarError() {
      this.avatarError = true;
    },

    logout() {
      // Remove userData from cookie
      // ? You just removed token from cookie. If you like, you can also make API call to backend to blacklist used token

      // Clear Cookies
      setCookie("logout", true);
      document.cookie = "logout=true; path=/; SameSite=Lax";

      deleteCookie("token");
      deleteCookie("role");
      deleteCookie("user");
      deleteCookie("idUser");
      deleteCookie("menuPermissions");
      deleteCookie("guidProfile");
      deleteCookie("famcos");
      const guidCompany = getCookie("guidCompany");
      if (guidCompany) {
        deleteCookie("guidCompany");
        deleteCookie("companyType");
        deleteCookie("divisa");
      }
      deleteCookie("idCatTypeProfile");
      deleteCookie("idCompany");
      deleteCookie("tasaDolar");
      deleteCookie("dolarBCV");

      sessionStorage.removeItem("app-session");
      sessionStorage.removeItem("session-minimal");
      // Reset ability
      this.$store.commit("appConfig/SET_RESET_TOKEN");
      this.$store.commit("appConfig/SET_RESET_STATE");
      this.$store.commit("appConfig/SET_RESET_ROLE");
      // this.$store.commit("appConfig/SET_RESET_GUID_COMPANY");
      this.$store.commit("appConfig/RESET_ACTIVE_COMPANY");
      this.$store.commit("appConfig/SET_RESET_DIVISA");
      this.$store.commit("appConfig/SET_RESET_SESSION_CONTEXT");
      this.$store.commit("appConfig/SET_RESET_ID_CAT_TYPE_PROFILE");
      this.$store.commit("appConfig/SET_RESET_ID_COMPANY");
      this.$store.commit("appConfig/SET_RESET_USER_ID");
      this.$store.commit("appConfig/SET_RESET_MENU_PERMISSIONS");
      this.$store.commit("appConfig/SET_RESET_DOLARBCV");
      this.$ability.update(initialAbility);
      // localStorage.clear();

      // sessionStorage.removeItem("app-session");
      // sessionStorage.removeItem("session-minimal");
      // Redirect to login page
      this.$router.push({ name: "landing" });
    },
  },
};
</script>
